import { useMemo } from "react";
import muiTheme from "components/MuiThemeProvider/theme";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import useLocale from "providers/LocaleProvider/useLocale";
import ThemeHelpers from "helpers/ThemeHelpers";
import useMergeProps from "hooks/useMergeProps";

const INITIAL_PROPS = {
  mode: "light" as "light" | "dark",
} as const;

interface ThemeProvider2024Props {
  children?: React.ReactNode;
  mode?: "light" | "dark";
}

function ThemeProvider2024(props: ThemeProvider2024Props) {
  const { mode, children } = useMergeProps(INITIAL_PROPS, props);
  const { locale } = useLocale();

  /**
   * Create a new theme with the selected locale
   * To learn more about MUI locales, check the documentation
   * @see https://mui.com/material-ui/guides/localization
   */
  const themeWithLocale = useMemo(
    () =>
      createTheme(muiTheme, ThemeHelpers.muiLocaleThemeConstructor(locale), {
        palette: { mode: mode },
      }),
    [locale, mode]
  );

  return <ThemeProvider theme={themeWithLocale}>{children}</ThemeProvider>;
}
export default ThemeProvider2024;
